/**
 * @file   : Destinations.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 4/15/2019, 8:26:40 PM
 */
import PropTypes from 'prop-types'
import React from 'react'

import Cont from '../../../external/components/layout/Cont'
import Section from '../../../external/components/layout/Section'
import DestinationsCmp, {
  TYPE_INFO,
} from '../../shared/destinations/DestinationsCmp'
import { getTranslation, isData } from '../InfoUtil'
import SectionAd from './SectionAd'

const Destinations = ({ intl, theme, section, infoData, mainConfig }) => {
  if (isData(section.data)) {
    const { data } = section

    return (
      <Cont>
        <DestinationsCmp
          type={TYPE_INFO}
          theme={theme}
          intl={intl}
          latitude={data.latitude}
          longitude={data.longitude}
          stateName={data.stateName}
          countryName={data.countryName}
          locationName={data.stateName}
          arrivalDate={null}
          departureDate={null}
          numToDisplay={data.numToDisplay}
          titleText={getTranslation(
            intl,
            section.title.token,
            section.title.default,
            infoData.infoToken,
          )}
          seeMoreText={getTranslation(
            intl,
            section.sectionLink.description.token,
            section.sectionLink.description.default,
            infoData.infoToken,
          )}
          seeMoreLink={section.sectionLink.link}
        />
        <SectionAd section={section} mainConfig={mainConfig} />
        <Section />
      </Cont>
    )
  }

  return null
}

Destinations.propTypes = {
  intl: PropTypes.object.isRequired,
  theme: PropTypes.string.isRequired,
  section: PropTypes.object,
  infoData: PropTypes.object,
  mainConfig: PropTypes.object,
}

export default Destinations
